/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SksOverviewController', SksOverviewController);

    SksOverviewController.$inject = ['$http', 'entity', 'DateUtils', '$location', '$window'];

    function SksOverviewController($http, entity, DateUtils, $location, $window) {
        var vm = this;
        vm.project = entity;
        vm.toggled = true;
        vm.from = angular.copy(vm.project.fromDate).setMonth(0, 1);
        vm.to = angular.copy(vm.project.untilDate).setMonth(11, 31);
        vm.accordionArray = [];
        vm.toggleAccordion = toggleAccordion;
        vm.goTo = goTo;
        vm.dataExport = dataExport;

        getOverview();

        function getOverview() {
            $http.get('api/board/sks/overview/', {
                params: {
                    projectId: entity.id,
                    from: DateUtils.convertLocalDateToServer(vm.from),
                    to: DateUtils.convertLocalDateToServer(vm.to)
                }
            }).then(function(response) {
                response.data.fromDate = DateUtils.convertLocalDateFromServer(response.data.fromDate);
                response.data.untilDate = DateUtils.convertLocalDateFromServer(response.data.untilDate);
                vm.sksOverview = response.data;
                vm.accordionArray = new Array(response.data.length);
                vm.accordionArray.fill(vm.toggled);
            });
        }

        function toggleAccordion() {
            vm.accordionArray = vm.accordionArray.map(function(x) {
                return !vm.toggled;
            });
            vm.toggled = !vm.toggled;
        }

        function goTo(id) {
            var url = $location.protocol() + "://" + location.host + "/#/board/projects/project/" + id + "/home";
            $window.open(url, "_self");
        }

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/board/sks/export/', {
                params: {
                    projectId: entity.id,
                    from: DateUtils.convertLocalDateToServer(vm.from),
                    to: DateUtils.convertLocalDateToServer(vm.to)
                }
            }).then(function (response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            });
        }
    }
})();
